import React from 'react'
import { CopyOutlined } from '@ant-design/icons'
import {
  VcnDetailsContainer,
  VcnTable,
  VcnTableRow,
  VcnTableLabel,
  VcnTableValue,
  CopyableText,
  CopyIcon,
} from './VcnPaymentManagement.styles'

const NOT_AVAILABLE = 'N/A'

// Bank info is static for ACH payments
const BANK_INFO = {
  bankName: 'First Premier Bank',
  bankAddress: '601 South Minnesota Avenue, Sioux Falls, SD 57104',
  routingNumber: '091408598',
}

export interface AchDetailsTableProps {
  fullName?: string
  accountNumber?: string
  mailingAddress?: string
  accountType?: string
  accountUse?: string
  onCopy: (text: string) => void
}

export function AchDetailsTable({
  fullName,
  accountNumber,
  mailingAddress,
  accountType,
  accountUse,
  onCopy,
}: AchDetailsTableProps) {
  const handleCopy = (text: string | undefined) => {
    if (text && text !== NOT_AVAILABLE) {
      onCopy(text)
    }
  }

  const rows = [
    {
      label: 'Full Name:',
      value: fullName || NOT_AVAILABLE,
      copyable: !!fullName,
    },
    {
      label: 'ACH Account Number:',
      value: accountNumber || NOT_AVAILABLE,
      copyable: !!accountNumber,
    },
    {
      label: 'Insured Mailing Address:',
      value: mailingAddress || NOT_AVAILABLE,
      copyable: !!mailingAddress,
    },
    {
      label: 'ACH Account Type:',
      value: accountType || NOT_AVAILABLE,
      copyable: false,
    },
    {
      label: 'ACH Account Use:',
      value: accountUse || NOT_AVAILABLE,
      copyable: false,
    },
    {
      label: 'Bank Name:',
      value: BANK_INFO.bankName,
      copyable: true,
    },
    {
      label: 'Bank Address:',
      value: BANK_INFO.bankAddress,
      copyable: true,
    },
    {
      label: 'Routing Number:',
      value: BANK_INFO.routingNumber,
      copyable: true,
    },
  ]

  return (
    <VcnDetailsContainer>
      <VcnTable>
        {rows.map((row) => (
          <VcnTableRow key={row.label}>
            <VcnTableLabel>{row.label}</VcnTableLabel>
            <VcnTableValue>
              {row.copyable ? (
                <CopyableText onClick={() => handleCopy(row.value)}>
                  {row.value}
                  <CopyIcon>
                    <CopyOutlined />
                  </CopyIcon>
                </CopyableText>
              ) : (
                row.value
              )}
            </VcnTableValue>
          </VcnTableRow>
        ))}
      </VcnTable>
    </VcnDetailsContainer>
  )
}
